module.exports = __webpack_public_path__ + "img/Pat-Menschner.f9d816c1.webp";